import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Grid,
} from '@mui/material';

/**
 * LoadingSkeleton Component
 *
 * Displays animated loading placeholders while content is being fetched
 */
const LoadingSkeleton = () => {
  return (
    <Box sx={{ width: '100%', mt: 4 }}>
      {/* Token Info Skeleton */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Skeleton variant="text" width="40%" height={40} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="80%" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="80%" />
            </Grid>
            <Grid item xs={12}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="90%" />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Image Skeleton */}
      <Card sx={{ mb: 3 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={400}
          sx={{ borderRadius: 2 }}
        />
      </Card>

      {/* Metadata Skeleton */}
      <Card>
        <CardContent>
          <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoadingSkeleton;
